import { IncomeType, Money } from "shared/types";
import { CombinedIncome } from "./income";
import { VerifiedBankStatement } from "./verified/bank-statment";

// eslint-disable-next-line sonarjs/redundant-type-aliases -- for better picture what is the key of the bank_statements Record<> type
type IncomeSourceId = number;

export type BankStatements = Record<IncomeSourceId, VerifiedBankStatement>;

export type CombinedIncomeReport = {
  bank_statements?: BankStatements;
  incomes: CombinedIncome[];
  net_income_analysis: NetIncomeAnalysis;
  payroll_connection_failure?: PayrollConnectionFailureReason | null;
  total_overrides?: Override;
  total_summary: TotalSummary;
};

export enum PayrollConnectionFailureReason {
  ConnectionFailed = "connection_failed",
  ConnectionTimedOut = "connection_timed_out",
  ProviderError = "provider_error"
}

export type TotalSummary = {
  self_reported_gross_monthly_total: number;
  submitted_incomes_count: number;
  monthly_housing_assistance: number;
  verified_gross_monthly_total: number;
  verified_net_monthly_total: number;
  total_monthly_debt: Money;
  debt_net_income_ratio?: number | null;
  debt_gross_income_ratio?: number | null;
  debt_self_attested_gross_income_ratio?: number | null;
  debts: Debt[];
};

type Debt = {
  name: string;
  description: string;
  amount: Money;
};
export type NetIncomeAnalysis = {
  [company: string]: NetIncomeAnalysisCompany;
};
type NetIncomeAnalysisCompany = {
  [month: string]: NetIncomeAnalysisVerboseData | number;
};

type NetIncomeAnalysisVerboseData = {
  total: number;
  sources: Source[];
};

interface Source {
  description: string;
  net_amount: number;
  pay_date: string; // e.g. "2022-04-21"
}

export type Override = {
  net_monthly_income: number;
  gross_monthly_income: number;
  updated_at: string;
  author: {
    id: number;
    name: string;
    email: string;
  };
};

export interface IncomeSourceMappedStatus {
  incomeId: number;
  incomeName: string;
  status?: "Rejected" | "Warning" | "Accepted" | "Started" | "Overridden";
  description?: string;
  type: IncomeType;
}

export type EditTransactionsDrawerData = Pick<
  CombinedIncome,
  "id" | "additional_data" | "type"
>;

export type EditIncomeModalData = Pick<
  CombinedIncome,
  "id" | "additional_data" | "type"
> & {
  grossMonthlyIncomeDollars: number;
  netMonthlyIncomeDollars: number;
  hasNetMonthlyIncome: boolean;
  incomeId?: number;
  isTotal: boolean;
};

export type OverrideIncomeModalData = Pick<
  CombinedIncome,
  "id" | "additional_data" | "type"
>;
